import { apiContractRequest } from './client';

// # OWNER: usar sesión y contexto existentes; las exportaciones no se reintentan automáticamente.
const base = '/api/owner/database';
export const ownerDatabaseApi = {
  overview: (refresh = false) => apiContractRequest(`${base}/overview`, { params: { refresh }, timeout: 60000, retryAttempts: 0 }),
  settings: body => apiContractRequest(`${base}/settings`, { method: 'PATCH', body, retryAttempts: 0 }),
  importInvoice: csv => apiContractRequest(`${base}/invoices`, { method: 'POST', body: { csv }, retryAttempts: 0 }),
  backups: () => apiContractRequest(`${base}/backups`, { retryAttempts: 0 }),
  startBackup: requestId => apiContractRequest(`${base}/backups`, { method: 'POST', body: { requestId }, timeout: 30000, retryAttempts: 0 }),
  download: async (id, type = 'archive') => {
    try { return await apiContractRequest(`${base}/backups/${encodeURIComponent(id)}/download`, { params: { type }, responseType: 'blob', timeout: 1800000, retryAttempts: 0 }); }
    catch (error) {
      if (error.data instanceof Blob) {
        try { const detail = JSON.parse(await error.data.text()); if (detail.message) error.message = detail.message; } catch { /* Conservar el error de transporte original. */ }
      }
      throw error;
    }
  },
};
